// Assets
import image1 from "../../../assets/images/food/grilled-chicken.webp";
import image2 from "../../../assets/images/food/baby-back-ribs.webp";
import image3 from "../../../assets/images/food/tacos-2.webp";

const HeroImageGrid: React.FC = () => {
  return (
    <section className="hero-image-grid padding-left-and-right padding-top-40 padding-bottom-80 display-grid gap-20">
      <div className="hero-image-grid-item">
        <img
          src={image1}
          className="hero-image-grid-image"
          alt="BBQ Grilled Chicken"
        />
      </div>
      <div className="hero-image-grid-column">
        <div className="hero-image-grid-item">
          <img
            src={image3}
            className="hero-image-grid-image"
            alt="Tacos Al Pastor"
          />
        </div>
        <div className="hero-image-grid-item">
          <img
            src={image2}
            className="hero-image-grid-image"
            alt="BBQ Baby Back Ribs"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroImageGrid;
